import TableData from '../../../components/ui/TableData'
import { Icon } from '@iconify/react'
import { useNav } from '../../../hooks/useNav'
import useGetAccount from './hooks/useGetAccount'
import { PATH } from '../../../data/router_path'
import { PAGE_SIZE } from '../../../data/queryFactories'
import { useState } from 'react'
import { Button } from '../../../components/ui/legacy'
import PopUpStatusTable from './components/PopUpStatusTable'
import useSelectAccounts from './hooks/useSelectAccounts'
import CreateAccountPopUp from './CreateAccountPopUp'
import EditAccountPopUp from './EditAccountPopUp'
import PopupGroupUsers from './components/PopupGroupUsers'
import ExportExcelAccountUser from './components/ExportExcelAccountUser'
import { LuEye } from 'react-icons/lu'
export default function AccountDataTable() {
  const navigate = useNav()
  const [openStatusPopup, setOpenStatusPopup] = useState(false)
  const [openAccountFormPopup, setOpenAccountFormPopup] = useState(false)
  const [accountEditUuid, setAccountEditUuid] = useState(null)
  const [openGroupsUsersPopup, setOpenGroupsUsersPopup] = useState(false)
  const {
    selectedAccount,
    selectAll,
    toggleSelectAccount,
    toggleSelectAll,
    newStatusCount,
    resetSelectAccount,
  } = useSelectAccounts()

  const {
    data: {
      pageNumber = 1,
      pageSize = PAGE_SIZE,
      users = [],
      totalItems = 0,
    } = {},
  } = useGetAccount()
  const detailViewFunction = (row) => {
    navigate(PATH.ACCOUNT.DETAIL(row.uuid))
  }
  const newestUsers = Object.values(
    users.reduce((acc, user) => {
      const id = user.id

      if (!acc[id]) {
        acc[id] = user
      } else {
        if (acc[id].createAt < user.createAt) {
          acc[id] = user
        }
      }

      return acc
    }, {})    
  )

  const columnMapping = [
    { key: 'id', value: 'Mã tài khoản' },
    { key: 'name', value: 'Tên tài khoản' },
    { key: 'joinDate', value: 'Ngày tạo' },
    { key: 'course', value: 'Khoá' },
    { key: 'groups', value: 'Nhóm' },
    { key: 'schoolEmail', value: 'Email trường' },
    { key: 'activate', value: 'Trạng thái' },
    // { key: 'books', value: 'Số sách đã tải' },
    // { key: 'devices', value: 'Thiết bị' },
  ]
  const columnWidths = {
    id: 'w-[8.33vw]',
    name: 'w-[13.33vw]',
    joinDate: 'w-[10vw]',
    course: 'w-[8.33vw]',
    groups: 'w-[10.83vw]',
    schoolEmail: 'w-[15vw]',
    // personalEmail: 'w-[15vw]',
    // phoneNumber: 'w-[10.83vw]',
    // faculty: 'w-[15vw]',
    // school: 'w-[15vw]',
    activate: 'w-[8.33vw]',
    // books: 'w-[13.33vw]',
    // devices: 'w-[8.33vw]',
  }

  const actionButtons = [
    {
      title: 'Chỉnh sửa',
      icon: (
        <Icon
          icon="ph:pencil-simple-line"
          className={'text-2xl text-main-grey'}
        />
      ),
      onClick: (row) => {
        setOpenAccountFormPopup(true)
        setAccountEditUuid(row.uuid)
      },
      label: 'Chỉnh sửa',
    },
    {
      title: 'Xem chi tiết tài khoản',
      icon: <LuEye className={'text-2xl font-light text-main-grey'} />,
      onClick: (row) => detailViewFunction(row),
      label: 'Xem chi tiết tài khoản',
    },
  ]

  return (
    <>
      <TableData
        data={newestUsers}
        columnMapping={columnMapping}
        columnWidths={columnWidths}
        detailView={detailViewFunction}
        actionButtons={actionButtons}
        paginationEnabled={true}
        dataType="tài khoản"
        currentPage={pageNumber}
        totalPages={Math.ceil(totalItems / pageSize)}
        pageSize={pageSize}
        totalItems={totalItems}
        path={PATH.ACCOUNT.LIST}
        selectedList={selectedAccount}
        selectAll={selectAll}
        toggleSelect={toggleSelectAccount}
        toggleSelectAll={toggleSelectAll}
        extraFunctions={[
          <Button
            variant="primary"
            onClick={() => setOpenAccountFormPopup(true)}
            className="gap-2 whitespace-nowrap"
            type="button"
          >
            <Icon
              icon="ph:plus"
              width="24px"
              height="24px"
              style={{ color: 'white' }}
            />
            Tạo tài khoản
          </Button>,
          <Button
            variant={'outline'}
            type="button"
            className="gap-2 whitespace-nowrap"
            onClick={() => setOpenGroupsUsersPopup(true)}
          >
            <Icon
              icon="ph:plus"
              width="24px"
              height="24px"
              style={{ color: 'black' }}
            />
            Phân nhóm tài khoản
          </Button>,
          <Button
            variant={'primary'}
            onClickHandler={() => setOpenStatusPopup(true)}
            disabled={selectedAccount?.size === 0}
            className={'gap-2 whitespace-nowrap'}
          >
            <Icon
              icon="ph:pencil-simple-line"
              width="24px"
              height="24px"
              className={'text-white'}
            />
            Thay đổi trạng thái
          </Button>,
          <ExportExcelAccountUser />,
        ]}
      />

      {openAccountFormPopup &&
        (accountEditUuid ? (
          <EditAccountPopUp
            closePopUp={() => {
              setOpenAccountFormPopup(false)
              setAccountEditUuid(null)
            }}
            uuid={accountEditUuid}
          />
        ) : (
          <CreateAccountPopUp
            closePopUp={() => {
              setOpenAccountFormPopup(false)
            }}
          />
        ))}
      {openStatusPopup && (
        <PopUpStatusTable
          openPopUp={openStatusPopup}
          closePopUp={() => setOpenStatusPopup(false)}
          data={Array.from(selectedAccount.values())}
          newStatusCount={newStatusCount}
          columnMapping={columnMapping}
          columnWidths={columnWidths}
          reset={resetSelectAccount}
        />
      )}
      {openGroupsUsersPopup && (
        <PopupGroupUsers
          onClose={() => setOpenGroupsUsersPopup(false)}
          dataUser={selectedAccount}
        />
      )}
    </>
  )
}
